module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "21",
      "height": "27",
      "stroke": "#000",
      "stroke-width": "2",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.69 22h5.6c.13.41.21.74.21 1a3 3 0 01-5.12 2.12A3 3 0 017.5 23c0-.26.07-.6.19-1h0z"
    }
  }), _c('circle', {
    attrs: {
      "cx": "10.5",
      "cy": "3.5",
      "r": "2.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.5 6c2.76 0 4.4.76 5.3 2.18 1.3 2.05 1.22 5.2 1.2 8.65V18c.26.97.94 2.2 2.12 4h0H1.85a39.8 39.8 0002.05-3.55c.08-.7.1-1.08.1-1.41v-.22-.67h0v-.78c0-2.99.08-5.66 1.35-7.41C6.28 6.67 7.89 6 10.5 6z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5546d66","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/notifications.vue
// module id = 3127247c85df87ca16ac
// module chunks = 89